import React, { } from "react";
import { Card, CardContent, CardHeader, Grid, Divider, Box, Typography, Stack, Button } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Consts from "../config/constants";

const ScholarshipsCards = ({ scholarshipData }) => {


    function redirectToBedukaBolsas() {
        const encodeUriInstitutionName =
		scholarshipData.institutionName &&
		encodeURIComponent(String(scholarshipData.institutionName)).replace(
			new RegExp('%2', 'g'),
			'+'
		)

	const encodeUriCourseName =
    scholarshipData.courseName &&
		encodeURIComponent(String(scholarshipData.courseName)).replace(
			new RegExp('%20', 'g'),
			'+'
		)
        
        window.open(`${Consts.BEDUKA_BOLSAS_WEB_URL}detalhes-da-oferta/${encodeUriInstitutionName}/${encodeUriCourseName}/${scholarshipData.scholarship_id}`)
    }

    const useStyles = makeStyles(() => ({
        button: {
            backgroundColor: '#ee3db6',
            '&:hover': {
                backgroundColor: '#ee3db6',
                opacity: '0.8'
            }
        }
    }));

    const classes = useStyles();

    return (
        <Card elevation={3} sx={{ height: '370px', width: '300px', paddingTop: '7px', paddingBottom: '7px', borderRadius: '20px' }}>
            <CardHeader
                title={
                    <Stack direction="column" justifyContent={'center'} alignItems={'center'} spacing={2}>
                        <Box component="img" style={{ height: '27px' }} src={`${scholarshipData.logoUrl}`} />
                        <Typography component="b" fontSize="20px" fontWeight="600" sx={{color: '#0b1880'}}>
                            Bolsa de {scholarshipData.percentualDiscount}%
                        </Typography>
                    </Stack>
                }
            />
            <Divider variant="middle" />
            <CardContent>
                <Stack width={'100%'} justifyContent={'center'} alignItems={'center'}>
                    <Box component="div" sx={{ backgroundColor: "#17bfdf", padding: '10px', borderRadius: '10px' }}>
                        <Typography component="span" sx={{ fontSize: '21px', fontWeight: '400', color: '#fff' }}>
                            {scholarshipData.courseName}
                        </Typography>
                    </Box>
                </Stack>
                <Grid container width={'100%'} justifyContent={'space-evenly'} alignItems={'center'} mt={'10px'}>
                    <Grid item>
                        <Typography component="span" color="primary" fontWeight="300" fontSize="18px">
                            {scholarshipData.modality}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography component="span" color="primary" fontWeight="300" fontSize="18px" >
                            {scholarshipData.shift}
                        </Typography>
                    </Grid>
                </Grid>
                <Stack justifyContent={'center'} alignItems={'center'} height={'30px'} mt={'10px'}>
                    <Typography component="span" color="primary" fontWeight="600" fontSize="18px" >
                        {scholarshipData.cityAndState}
                    </Typography>
                </Stack>
                <Stack justifyContent={'center'} alignItems={'center'} height={'20px'} paddingY={'15px'}>
                    <Typography component="span" color="primary" fontWeight="200" fontSize="15px">
                        {scholarshipData.campus}
                    </Typography>
                </Stack>
                <Divider variant="middle" />
                <Stack justifyContent={'center'} alignItems={'center'} height={'40px'}>
                    <Typography color="primary" fontSize="18px" fontWeight="600" >
                        A partir de <Box component="span" fontSize='18px' fontWeight='600' sx={{ color: "#17bfdf" }}> R$ {scholarshipData.paymentPerMounthWithDiscount} </Box>
                    </Typography>
                </Stack>
                <Stack justifyContent={'center'} alignItems={'center'} height={'50px'}>
                    <Button
                        fullWidth
                        variant="contained"
                        size="medium"
                        className={classes.button}
                        onClick={redirectToBedukaBolsas}
                    >
                        Saber mais
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    )
}

export default ScholarshipsCards;